import { SearchForTaskSubjectsItem } from "core/queries/SearchForTaskSubjects";
import { SearchForTasksItem } from "core/queries/SearchForTasks";

export const getSearchItemId = (
  subject: SearchForTaskSubjectsItem | SearchForTasksItem,
) => {
  const { resource } = subject;
  switch (resource.__typename) {
    case "CufSpace":
      return `Cuf::Space|${resource.id}`;
    case "Building":
      return `${resource.__typename}|${resource.buildingId}`;
    default:
      return resource.id;
  }
};
